module.exports = __webpack_public_path__ + "static/media/couches-12.4b26a726.jpg";